<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div
	*ngIf="!headerTextEmpty"
	[ngClass]="{ 'has-error-summary-container': hasError, 'summary-container': !hasError }"
	class="flex-layout-column"
>
	<div class="flex flex-100 flex-layout-row">
		<button mat-icon-button (click)="toggleExpansion()" class="flex expand-button-width" [tabIndex]="startTabIndex">
			<orbit-icon *ngIf="expanded" title="Toggle expansion" class="expand-collapse-arrow toggle-button-padding" name="expand_less"></orbit-icon>
			<orbit-icon *ngIf="!expanded" title="Toggle expansion" class="expand-collapse-arrow toggle-button-padding" name="expand_more"></orbit-icon>
		</button>

		<div class="flex flex-93 flex-layout-row flex-layout-align-start-center">
			<span class="header flex flex-90" matTooltip="{{ headerText }}" matTooltipShowDelay="750" matTooltipPosition="above">{{
				headerText
			}}</span>
			<div *ngIf="showCopyButton" class="flex flex-10">
				<orbit-icon class="copy-icon" (click)="emitCopy()" name="content_copy"></orbit-icon>
			</div>
		</div>
	</div>

	<div *ngIf="expanded && (hasContent || !bodyTextEmpty)" class="body flex flex-100 flex-layout-row">
		<div *ngIf="!bodyTextEmpty" class="flex flex-7"></div>

		<div *ngIf="!bodyTextEmpty" class="flex flex-93">
			<span class="body-text">{{ bodyText }}</span>
		</div>

		<div *ngIf="hasContent" class="content flex flex-100">
			<ng-content></ng-content>
		</div>
	</div>
</div>
